

export const getInterval = (state) => state.interval
